module.exports = __webpack_public_path__ + "img/crm_sales1.d0de34e9.png";